import { CompanyBanner } from '../../site-check-in/components/CompanyBanner';

export const SessionHeader = ({
  companyName,
  locationAddress,
  siteCode,
}: {
  companyName: string | null;
  locationAddress: string | null;
  siteCode: string | null;
}) => (
  <>
    <div className="flex justify-center">
      <img src="/ortomate-pay-logo.svg" alt="Orto-Mate Pay" className="h-7" />
    </div>
    {companyName && <CompanyBanner companyName={companyName} locationAddress={locationAddress} />}
    {siteCode && (
      <div className="space-y-1 text-center">
        <h2 className="text-2xl font-bold tracking-tight">Site {siteCode}</h2>
      </div>
    )}
  </>
);
